import React from "react";
import { Routes, Route } from "react-router-dom";
import ListNews from "../Components/News and Article/listNews";
import AddNews from "../Components/News and Article/addNews";
import EditNews from "../Components/News and Article/editNews";
import ViewNews from "../Components/News and Article/viewNews";
const NewsRoutes = () => {
  return (
    <Routes>
      <Route path="/news_and_articles" element={<ListNews></ListNews>}></Route>
      <Route
        path="/news_and_articles/add"
        element={<AddNews></AddNews>}
      ></Route>
      <Route
        path="/news_and_articles/edit/:id"
        element={<EditNews></EditNews>}
      ></Route>
      <Route
        path="/news_and_articles/view/:id"
        element={<ViewNews></ViewNews>}
      ></Route>
    </Routes>
  );
};

export default NewsRoutes;
